module.exports = __webpack_public_path__ + "static/media/repairs-maintenance.18d6b2f5.svg";